function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M407 81c24-24 63-24 87 0 24 23 24 62 0 87 0 0-256 255-260 259-24 24-63 24-87 0L18 298c-24-25-24-63 0-87s63-24 87 1l86 86z"
})));